import { SxProps } from '@mui/material';

export const storeLocatorDetailsSX: SxProps = {
	marginTop: '10px',
};

export const storeLocatorDetailsGoBackSX: SxProps = {
	color: 'secondary.main',
	width: '100px',
	'&:hover': {
		textDecoration: 'underline',
		cursor: 'pointer',
	},
	'> svg': {
		marginBottom: '-7px',
	},
};

export const storeLocatorDetailsContainerSX: SxProps = {
	marginTop: '10px',
	marginLeft: '10px',
};
